// Hideo - what the lists of items (hooks, sources, saved videos, creators, keywords) do alike: saving an item from its
// dialog, deleting it, searching it, the first line of a dropped text
import type { ProfileData } from './types'

/** Saves an item from its dialog: editing = replaces the item with its id (nothing if it is gone), otherwise adds it.
 *  Returns whether it was added */
export function putItem<T extends { id: string }>(list: T[], item: T, editing: boolean): boolean {
  if (editing) {
    const i = list.findIndex(x => x.id === item.id)
    if (i !== -1) list[i] = item
    return false
  }
  list.push(item)
  return true
}

type ItemList = 'vault' | 'sources' | 'savedVideos' | 'creators' | 'keywords'
/** Removes an item from one of the profile's lists (a new list); true if it was there. The caller saves. */
export function removeItem(d: ProfileData, key: ItemList, id: string): boolean {
  const list = d[key] as { id: string }[], kept = list.filter(x => x.id !== id)
  ;(d as unknown as Record<ItemList, unknown>)[key] = kept
  return kept.length !== list.length
}

/** Search: the query (already lower case) is in one of the texts, without case; an empty query matches everything */
export const textMatches = (q: string, ...texts: unknown[]): boolean => !q || texts.join(' ').toLowerCase().includes(q)

/** The first line of a text, trimmed */
export const firstLine = (text: unknown): string => String(text || '').split('\n')[0].trim()

/** The lists whose items belong to a project (projectId): moved, counted and repaired together */
export const PROJECT_LISTS = ['videos', 'vault', 'creators', 'sources', 'savedVideos', 'series', 'keywords'] as const
